/* tslint:disable */
/* eslint-disable */
/**
 * BFF Web Product
 * API reference used to call the backend from the web frontend
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PlanPriceDto
 */
export interface PlanPriceDto {
    /**
     * 
     * @type {string}
     * @memberof PlanPriceDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanPriceDto
     */
    'interval': PlanPriceDtoIntervalEnum;
    /**
     * 
     * @type {number}
     * @memberof PlanPriceDto
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof PlanPriceDto
     */
    'oldPrice': number | null;
    /**
     * 
     * @type {number}
     * @memberof PlanPriceDto
     */
    'installments': number;
}

/**
    * @export
    * @enum {string}
    */
export enum PlanPriceDtoIntervalEnum {
    MONTHLY = 'monthly',
    QUARTERLY = 'quarterly',
    SEMIANNUALLY = 'semiannually',
    ANNUALLY = 'annually'
}


